<template>
  <div class="login-page">
    <div class="background-image"></div>
    <div class="login-container">
      <div class="login-box">
        <h3>欢迎登录本系统</h3>
        <el-form :model="loginForm" @submit.native.prevent="handleLogin">
          <el-form-item>
            <el-input v-model="loginForm.loginName" placeholder="用户名" class="login-input" @focus="handleFocus"
              @blur="handleBlur">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="loginForm.pwd" type="password" placeholder="密码" class="login-input" @focus="handleFocus"
              @blur="handleBlur">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="login-button transparent-button" @click="handleLogin">用户登录</el-button>

          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="title-container">
      <h1 class="system-title">水利信息管理平台</h1>
      <h2 class="system-subtitle">Smart Irrigation District Information Platform</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginPage",
  data() {
    return {
      loginForm: {
        loginName: '',
        pwd: ''
      }
    };
  },
  methods: {
    async handleLogin() {
      let compponents = this; //声明一个变量赋值为this，以便在axios.post方法的作用域中使用。
      // 在这里处理登录逻辑
      let username = this.username;
      let password = this.password;
      let response = await this.$asyncPost('signIn', this.loginForm);
      if (response.success) {
        let { userInfo } = response; //{userInfo} = result 的语法形式 等同于 let userInfo=result.userInfo
        let { token } = response;
        compponents.$store.dispatch("user/setToken", token); //通过调用Stroe中的user modules 声明的 setToken 将token 在vuex中定义 以便后期随时调用
        compponents.$store.dispatch("user/setUserInfo", userInfo); //通过调用Stroe中的user modules 声明的 setUserInfo 将t用户信息 在vuex中定义 以便后期随时调用
        compponents.$router.push("/");
        compponents.$message.success('登录成功');
      } else {
        compponents.$message.warning(response.message);
      }
    },
    handleFocus() {
      // Handle focus event
    },
    handleBlur() {
      // Handle blur event
    }
  }
};
</script>

<style lang="scss">
.login-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'A';
  height: 100vh;
  background-image: url('https://qiniu.shunmingelectronic.com/irrigation/image/wp9475397.jpg');
  background-size: cover;
  background-position: center;
  padding: 0 10%;
}

.background-image {
  /* flex: 1; */
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  width: 40%;
  background: rgb(0 0 0 / 40%);
  margin-left: -600px;
}




.login-box {
  width: 80%;
  padding: 20px;
  background: rgb(131 131 131 / 0);
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0);
}

.login-box h3 {
  margin-bottom: 0.5rem;
  color: #e2edff;
}

.el-form-item {
  margin-bottom: 20px;
  text-align: left;

  .login-button {
    height: 50px;
    width: 100%;
    font-family: 'A';
  }

  .transparent-button {
    background-color: transparent !important;
    border: 0.055rem solid #9298a57a !important;
    color: white !important;
  }

  .transparent-button:hover {
    background-color: rgba(0, 0, 0, 0.1) !important;
  }
}

.login-input {
  height: 60px;
  width: 600px;
  font-family: 'A';
  color: #ffffff;
  text-align: left;

  .el-input__wrapper {
    background-color: #ffdada00;


  }
}



.title-container {
  text-align: center;
  margin-top: -380px;

}

.system-title {
  font-size: 1.4rem;
  font-family: 'A';
  margin: 0;
  background: linear-gradient(to right, #d9eeff, #a0edff, #a0fee0);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  /* 兼容WebKit浏览器 */
  color: transparent;
  /* 兼容标准CSS */

}

.system-subtitle {
  font-size: 16px;
  color: #ffffff;
  margin: 5px 0 20px 0;
}
</style>
